import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=156856c0&scoped=true&"
import script from "./Flight.vue?vue&type=script&lang=js&"
export * from "./Flight.vue?vue&type=script&lang=js&"
import style0 from "./Flight.vue?vue&type=style&index=0&id=156856c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156856c0",
  null
  
)

export default component.exports